import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import colors from "assets/theme/base/colors";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import PropTypes from "prop-types";
import VuiProgress from "./VuiProgress";

export function AppProgressCard({ bgColor, title, count, progress, percentage, legend }) {
  const { info } = colors;

  return (
    <Card sx={{ padding: "25px" }}>
      <VuiBox>
        <VuiBox sx={({ breakpoints }) => ({
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "14px",
          [breakpoints.down("md")]: {
            flexDirection: "column",
            alignItems: "flex-start",
          },
        })}>
          <VuiTypography
            variant="caption"
            color={bgColor === "white" ? "text" : "white"}
            opacity={bgColor === "white" ? 1 : 0.7}
            textTransform="capitalize"
            fontWeight={title.fontWeight}
            fontSize="16px"
          >
            {title.text}
          </VuiTypography>
          <VuiTypography
            variant="subtitle1"
            fontWeight="bold"
            color="white"
            fontSize="24px"
            sx={({ breakpoints }) => ({
              [breakpoints.down("md")]: {
                fontSize: "20px",
                textAlign: "right",
              },
              [breakpoints.only("lg")]: {
                fontWeight: "700",
                lineHeight: "33px",
              },
            })}
          >
            {count}{" "}
            <VuiTypography
              variant="button"
              color={percentage.color}
              fontWeight="bold"
              sx={({ breakpoints }) => ({
                [breakpoints.only("lg")]: {
                  fontSize: "10px",
                },
                [breakpoints.only("xl")]: {
                  fontSize: "12px",
                },
              })}
            >
              {percentage.text}
            </VuiTypography>
          </VuiTypography>
        </VuiBox>
        <VuiProgress color="info" value={progress <= 100 ? progress : 100} sx={{ background: "#2D2E5F" }} />
        <VuiBox sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "6px",
        }}>
          <VuiTypography
            variant="caption"
            color={bgColor === "white" ? "text" : "white"}
            opacity={bgColor === "white" ? 1 : 0.7}
            textTransform="capitalize"
            fontWeight={title.fontWeight}
            fontSize="14px">
            {legend.initial}
          </VuiTypography>
          <VuiTypography
            variant="caption"
            color={bgColor === "white" ? "text" : "white"}
            opacity={bgColor === "white" ? 1 : 0.7}
            textTransform="capitalize"
            fontWeight={title.fontWeight}
            fontSize="14px">
            {legend.final}
          </VuiTypography>
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

// Setting default values for the props of AppProgressCard
AppProgressCard.defaultProps = {
  bgColor: "white",
  title: {
    fontWeight: "medium",
    text: "",
  },
  percentage: {
    color: "success",
    text: "",
  },
  direction: "right",
};

// Typechecking props for the AppProgressCard
AppProgressCard.propTypes = {
  bgColor: PropTypes.oneOf([
    "white",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  title: PropTypes.PropTypes.shape({
    fontWeight: PropTypes.oneOf(["light", "regular", "medium", "bold"]),
    text: PropTypes.string,
  }),
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  direction: PropTypes.oneOf(["right", "left"]),
};
